export default {
  SET_INCIDENTS(state, incidentdata) {
    state.incidents = incidentdata;
  }
}
